.capacityPopup {
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(100% + var(--mantine-spacing-xs));
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: var(--mantine-radius-md);
    box-shadow:
        0px 4px 8px rgba(3, 7, 18, 0.03),
        1px 16px 30px rgba(3, 7, 18, 0.05);
    z-index: 5;
    pointer-events: none;
}

.capacityTitle {
    font-size: var(--mantine-font-size-sm);
    font-weight: 600;
    color: var(--mantine-color-dark-7);
    line-height: 1.3;
}

.capacityMessage {
    font-size: var(--mantine-font-size-xs);
    color: var(--mantine-color-dimmed);
    line-height: 1.4;
    margin-top: 2px;
}
